export const useQuery = (queryParam: string) => {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    return params.get(queryParam);
  } else {
    return undefined;
  }
};
